<!-- Modal Change Company Image -->
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">
        <span>Atualizar Imagem da Empresa</span>
      </h5>
    </div>
    <div class="modal-body">
      <app-update-company-image
        [company]="selectedCompany"
      ></app-update-company-image>
    </div>
  